<template>
  <div class="sso-wrapper">
    <div class="sign-in-buttons-separator">
      <hr>
      <span>{{ $t('login.or') }}</span>
      <hr>
    </div>
    <div class="sso-buttons">
      <!-- GOOGLE SIGN IN BUTTON IMPLEMENTATION -->
      <google-sign-in v-if="fairConfig.GA_SIGNIN_CLIENT_ID && fairConfig.GA_TAG" 
        :buttonLabel="getButtonLabelFor('google')"
      />
      <!-- LINKEDIN SIGN IN BUTTON IMPLEMENTATION -->
      <linked-in-sign-in v-if="fairConfig.LN_CLIENT_ID && fairConfig.LN_CLIENT_SECRET" 
        :buttonLabel="getButtonLabelFor('linkedIn')"
      />
    </div>
  </div>
</template>

<script>
import GoogleSignIn from "./GoogleSignIn";
import LinkedInSignIn from "./LinkedInSignIn";
import { mapState } from 'vuex'
export default {
  components: {
    LinkedInSignIn,
    GoogleSignIn
  },
  data () {
    return {
      text: ''
    }
  },
  computed: {
    ...mapState(['fairConfig']),
    currentPath () {
      return this.$route.path;
    }
  },
  methods: {
    getButtonLabelFor (ssoProvider) {
      switch(this.currentPath) {
        case '/register': return this.$t(ssoProvider + '.signUp')
        default: return this.$t(ssoProvider + '.signIn')
      }
    }
  }
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.sso-wrapper {
  margin: 0 auto;
  width: 100%;
  .sso-buttons {
    display: flex;
    flex-direction: column;
    > * {
      margin: 10px 0;
    }
  }
}
.sign-in-buttons-separator {
  display: flex;
  justify-content: center;
  opacity: 0.2;
  user-select: none;
  margin-top: 20px;
  hr {
    background-color: rgb(0, 0, 0);
    border: none;
    height: 1px;
    border-color: initial;
    width: 47%;
  }
}
</style>